import { Check } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { ServiceCard } from "@/components/site/ServiceCard";
import { CTABanner } from "@/components/site/CTABanner";
import { Seo } from "@/components/site/Seo";
import { Reveal } from "@/components/site/Reveal";
import { COMMERCIAL_SERVICES } from "@/lib/site";

const AUDIENCES = [
  "Strata managers",
  "Building managers",
  "Property managers",
  "Owners corporations",
  "Commercial property managers",
  "Small businesses & retail premises",
];

const Commercial = () => (
  <>
    <Seo
      title="Commercial Cleaning Sydney | Office & Strata Cleaning | Oz SpotNest"
      description="Professional commercial and industrial cleaning across Sydney, NSW — office cleaning, strata & building cleaning for property managers, strata managers and businesses. Request a quote."
    />
    <PageHero
      eyebrow="Commercial & Industrial"
      title="Professional"
      highlight="Commercial Cleaning"
      description="Keep your workplace, building or commercial property clean, presentable and ready for staff, customers, residents and visitors."
    />
    <section className="section-pad" data-testid="commercial-services-list">
      <div className="container-site grid gap-8 md:grid-cols-2">
        {COMMERCIAL_SERVICES.map((s, i) => (
          <ServiceCard key={s.id} service={s} index={i} />
        ))}
      </div>
    </section>
    <section className="section-pad bg-slate-50" data-testid="commercial-who-we-help">
      <div className="container-site grid items-center gap-10 lg:grid-cols-2">
        <Reveal>
          <span className="eyebrow">Who we work with</span>
          <h2 className="mt-4 text-3xl font-bold tracking-tight sm:text-4xl">
            Built for the people who keep buildings running
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed sm:text-lg">
            We work directly with the people responsible for how a property looks and feels —
            providing clear quotes, reliable scheduling and consistent presentation.
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <ul className="grid gap-3 sm:grid-cols-2">
            {AUDIENCES.map((a) => (
              <li
                key={a}
                className="flex items-center gap-3 rounded-2xl border border-slate-100 bg-white p-4 text-sm font-semibold text-navy-800 shadow-sm"
              >
                <Check className="h-4 w-4 shrink-0 text-emerald-500" strokeWidth={3} />
                {a}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
    <CTABanner
      heading="Looking for a Reliable Commercial Cleaner?"
      text="Tell us about your building or workplace and we'll prepare a cleaning proposal suited to your property."
      ctaLabel="Request a Quote"
    />
  </>
);

export default Commercial;
